import React, {Fragment} from "react";

export const List = ({state, handler, addHandler = null, removeHandler = null, args}) => (
    <Fragment>
        <div className='multiple-fields-container'>
            {state.map((item, index) => (
                <div key={index} style={{display: 'flex', width: '100%'}}>
                    <input
                        type="text"
                        value={item}
                        onChange={e => handler(e.target.value, index, args)}
                    />
                    {removeHandler?(
                        <button type="button" onClick={() => removeHandler(index,args)} className="close" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    ):''}
                </div>
            ))}
        </div>
        {addHandler?<button onClick={() => addHandler(args)}>Add field</button>:''}
    </Fragment>
)